import { transformRepeatBet } from "../../services/UserGroup.js";
import { APP_CONFIG } from "../constants/global-variables.js";

export async function mybet(id) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/mybet/${id}`;

  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function repeatbetinfo(id) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/repeatbetinfo/${id}`;

  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });
    return transformRepeatBet(res.data);
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function repeatLastBet() {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/lastbettorepeat`;

  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });
    return transformRepeatBet(res.data);
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function betdetailsbynumber(betnumber) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/betdetailsbynumber/${betnumber}`;

  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });
    return transformRepeatBet(res.data);
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

// export async function cancelbetbynumber(betNumber) {
//   const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/cancelbetbynumber/${betNumber}`;

//   try {
//     const res = await axios.post(
//       url,
//       {}, // no body needed if your API only requires the URL path
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );
//     return res.data; // return the server’s response
//   } catch (err) {
//     console.error("Error canceling bet:", err);
//     throw err;
//   }
// }

export async function cancelbetbynumber(betNumber) {
  const options = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Content-Type": "application/json",
    },
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/cancelbetbynumber/${betNumber}`;

  try {
    const res = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}
